import { AdvisorsLayout, AdvisorProfileSection } from '@src/components/sco/Advisors'

// L7: 404 for an unknown slug/id, 410 for a profile this viewer may not see (cookies forwarded).
export { memberProfileGetServerSideProps as getServerSideProps } from '@src/lib/memberProfileServerSideProps'

export default function Page() {
  return (
    <AdvisorsLayout>
      <AdvisorProfileSection />
    </AdvisorsLayout>
  )
}
